import { useContext, createContext, useState } from "react";
import { useNavigate } from "react-router-dom";

const PlayroomContext = createContext();

const PlayroomProvider = ({ children }) => {

    const [allPlayrooms, setAllPlayrooms] = useState([]);
    const [choosenPlayroom, setChoosenPlayroom] = useState(null);
   

    return <PlayroomContext.Provider value={{ allPlayrooms, setAllPlayrooms, setChoosenPlayroom, choosenPlayroom}}>
        {children}
    </PlayroomContext.Provider>;
};

export default PlayroomProvider;

export const usePlayrooms = () => {
    return useContext(PlayroomContext);
};